import { random, range } from 'lodash';

export const printMoney = (money: number, currency: string = 'UGX') => {
  if (money === 0) return `${currency} 0.00`;
  try {
    return money ? (
      `${currency} ${new Intl.NumberFormat('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(money)}`
    ) : '';
  } catch (e) {
    return '';
  }
};

export const printNumber = (number: number) => {
  if (number === 0) return '0';
  try {
    return number ? new Intl.NumberFormat().format(number) : '';
  } catch (e) {
    return '';
  }
};

export const printFloatNumber = (number: number) => {
  if (number === 0) return '0';
  try {
    return number ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(number) : '';
  } catch (e) {
    return '';
  }
};

export const printDecimal = (number: number) => {
  if (number === 0) return '0.00';
  try {
    return number ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(number) : '';
  } catch (e) {
    return '';
  }
};

export const printInteger = (number: number) => {
  if (number === 0) return '0';
  try {
    return number ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(number) : '';
  } catch (e) {
    return '';
  }
};

export const randomInt = (min = 0, max = 10): number => random(min, max);

export const intRange = (min = 0, max = 10): number[] => range(min, max);
